var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.998 0C10.5224 0 8.10235 0.733112 6.04393 2.10663C3.9855 3.48015 2.38116 5.43238 1.43377 7.71645C0.48638 10.0005 0.2385 12.5139 0.721475 14.9386C1.20445 17.3634 2.39659 19.5907 4.14713 21.3388C5.89768 23.087 8.12801 24.2775 10.5561 24.7598C12.9842 25.2421 15.5009 24.9946 17.7881 24.0485C20.0753 23.1024 22.0302 21.5002 23.4056 19.4446C24.781 17.389 25.5151 14.9723 25.5151 12.5C25.5116 9.18587 24.1917 6.00848 21.8451 3.66503C19.4984 1.32158 16.3167 0.00349978 12.998 0ZM19.738 13.4615H12.998C12.7427 13.4615 12.4978 13.3602 12.3172 13.1799C12.1366 12.9996 12.0352 12.755 12.0352 12.5V5.76923C12.0352 5.51421 12.1366 5.26964 12.3172 5.08932C12.4978 4.909 12.7427 4.80769 12.998 4.80769C13.2534 4.80769 13.4983 4.909 13.6789 5.08932C13.8595 5.26964 13.9609 5.51421 13.9609 5.76923V11.5385H19.738C19.9934 11.5385 20.2383 11.6398 20.4189 11.8201C20.5994 12.0004 20.7009 12.245 20.7009 12.5C20.7009 12.755 20.5994 12.9996 20.4189 13.1799C20.2383 13.3602 19.9934 13.4615 19.738 13.4615Z",
    fill: "#58B310"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTime);
export default __webpack_public_path__ + "static/media/green_time.520ceb9ce75c0dd63d46c7ed4ffb2b6f.svg";
export { ForwardRef as ReactComponent };